export { default as TemplatesActions, types as TemplatesTypes } from './actions';
export { default as TemplateSagas } from './sagas';
export { default as TemplateReducers } from './reducers';
